/**
 * 說明 : 客戶資料與後端API調用的非同步行為
 */
import {createAsyncThunk} from '@reduxjs/toolkit';

import BaseAPI from './BaseAPI';

// 新增員工資訊
export const addEmployee = createAsyncThunk(
  'employee/addEmployee',
  async (employee, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.postWithAuth('/employee', employee, token);
      return data;
    } catch (err) {
      console.error('add department error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 修改員工資訊
export const editEmployee = createAsyncThunk(
  'employee/editEmployee',
  async (department, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.putWithAuth('/employee', department, token);
      return data;
    } catch (err) {
      console.error('edit department error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 修改員工狀態
export const editEmployeeStatus = createAsyncThunk(
  'employee/editEmployeeStatus',
  async ({employeeCodes, status}, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.putWithAuth(
        '/employee/status',
        {employeeCodes: employeeCodes, flgStatus: status},
        token,
      );
      return data;
    } catch (err) {
      console.error('update customer status error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得員工資料
export const fetchCustomer = createAsyncThunk(
  'customer/fetchCustomer',
  async (customerCode, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth(
        `/customer/${customerCode}`,
        null,
        token,
      );
      return data;
    } catch (err) {
      console.error('fetch elevator error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得員工清單列表
export const fetchEmployeeList = createAsyncThunk(
  'employee/fetchEmployeeList',
  async (
    {
      employeeName,
      employeeCode,
      positionCode,
      departmentCode,
      requireSameDepartment = false,
    },
    {getState, rejectWithValue},
  ) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth(
        '/employee',
        {
          employeeName,
          employeeCode,
          positionCode,
          departmentCode,
          requireSameDepartment,
        },
        token,
      );
      return data;
    } catch (err) {
      //   console.error('fetch elevator list error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得有效的職位名稱選單
export const fetchEmployeeSelection = createAsyncThunk(
  'employee/fetchEmployeeSelection',
  async (_, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth(
        '/selection/employee',
        null,
        token,
      );
      return data;
    } catch (err) {
      console.error('fetch position selection error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 獲取未分配帳號的員工
export const fetchAvailableEmployeeList = createAsyncThunk(
  'setting/fetchAvailableEmployeeList',
  async (_, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth(
        '/setting/EmployeeSelections',
        null,
        token,
      );
      return data;
    } catch (error) {
      console.error('fetch available employee list error', error.response.data);
      return rejectWithValue(error.response.data);
    }
  },
);
